import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form';

import DashBoard from '../../components/Dashboard';
import PropertyForm from '../../components/Property/PropertyForm';
import { getList } from '../../redux/modules/user/action';
import { editProperty, getPropertyDetail, deletePropertyImage, getTimeline } from '../../redux/modules/property/action';

class EditProperty extends React.Component {
  componentDidMount () {
    const { dispatch, match } = this.props;
    dispatch(getList());
    console.log('match.params.propertyId', match.params.id);
    dispatch(getPropertyDetail(match.params.id));
  }

  addProperty = (formData) => {
    const { dispatch, match } = this.props;
    dispatch(editProperty(formData, match.params.id));
    dispatch(reset('editProperty'));
  }

  deleteItem = (imageId) => {
    const { dispatch } = this.props;
    dispatch(deletePropertyImage(imageId));
  }

  getTimelineIds = (event) => {
    const { dispatch } = this.props;
    dispatch(getTimeline(event.target.value));
  }

  render() {
    const { handleSubmit, userList, message, propertyImages, timelineDetails } = this.props;
    return (
      <DashBoard>
        <PropertyForm
          handleSubmit={handleSubmit}
          addProperty={this.addProperty}
          userList={userList}
          message={message}
          propertyImages={propertyImages}
          deleteImage={this.deleteItem}
          formName='Edit'
          timelineDetails={timelineDetails}
          getTimelineIds={this.getTimelineIds}
        />
      </DashBoard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    initialValues: state.property.details,
    userList: state.user.list,
    message: state.property.message,
    propertyImages: state.property.details && state.property.details.images,
    timelineDetails: state.property.timelineDetails
  }
}

export default connect(mapStateToProps)(reduxForm({
  form: "editProperty",
  enableReinitialize: true
})(EditProperty));